module.exports = __webpack_public_path__ + "media/images/elionline/eli_footer-8e176435303258162313ec4e87dfde97.svg";